import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title = "Instabuild - Building Materials & Construction Products Online",
  description = "Shop quality building materials, construction products, interior & exterior supplies at Instabuild. Find roofing, lumber, tools, insulation, and more. Fast delivery across Canada.",
  keywords = "building materials, construction supplies, roofing materials, lumber, tools, insulation, drywall, building products, construction products, home improvement, interior materials, exterior materials, construction tools, building supplies Canada",
  image,
  url,
  type = "website"
}) => {
  const isBrowser = typeof window !== "undefined";
  // TODO: Verify logo512.png exists in public folder - if not, update path or create the file
  const defaultImage = image || (isBrowser ? `${window.location.origin}/logo512.png` : "/logo512.png");
  const defaultUrl = url || (isBrowser ? window.location.href : "");
  const fullTitle = title.includes("Instabuild") ? title : `${title} | Instabuild`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Instabuild" />
      <meta name="robots" content="index, follow" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={defaultUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={defaultImage} />
      <meta property="og:site_name" content="Instabuild" />
      {/* TODO: VERIFY - Confirm locale is correct (en_CA for Canada) */}
      <meta property="og:locale" content="en_CA" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={defaultUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={defaultImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={defaultUrl} />

      {/* Structured Data - Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Instabuild",
          // TODO: VERIFY - Confirm actual production domain URL (currently set to instabuild.com, but baseUrl.js shows instabuild.com)
          "url": "https://www.instabuild.com",
          "logo": defaultImage,
          "description": description,
          "address": {
            "@type": "PostalAddress",
            // TODO: VERIFY - Confirm address matches actual business location
            "streetAddress": "7337 137 St",
            "addressLocality": "Surrey",
            "addressRegion": "BC",
            "postalCode": "V3W 1A4",
            "addressCountry": "CA"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            // TODO: VERIFY - Confirm phone number format and accuracy
            "telephone": "+1-604-313-2828",
            "contactType": "customer service",
            // TODO: VERIFY - Confirm email address is correct and active
            "email": "info@instabuild.com"
          },
          "sameAs": [
            "https://x.com/Instabuildpro",
            "https://www.instagram.com/instabuild.official/",
            "https://www.facebook.com/profile.php?id=61585211781544",
            "https://www.youtube.com/@InstaBuild.official"
          ]
        })}
      </script>

      {/* Structured Data - WebSite */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Instabuild",
          // TODO: VERIFY - Confirm actual production domain URL matches this
          "url": "https://www.instabuild.com",
          "potentialAction": {
            "@type": "SearchAction",
            "target": {
              "@type": "EntryPoint",
              // TODO: VERIFY - Confirm search URL format matches actual search endpoint (currently uses 'q' param, but app uses 'search' param - needs update to: /search?search={search_term_string})
              "urlTemplate": "https://www.instabuild.com/search?q={search_term_string}"
            },
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
